<template>
  <div :class="classes" v-bind="$attrs" v-on="$listeners">
    <!-- @slot Card body content -->
    <slot />
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    /**
     * Makes the indents slightly smaller.
     */
    dense: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes() {
      return [
        "am-card-body",
        {
          "am-card-body--dense": this.dense
        }
      ];
    }
  }
};
</script>
